import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorHandlerService } from '@qaroni-core/services/commons/error-handler/error-handler.service';
import { QaroniDialogConfig } from '@qaroni-core/types/dialogs/qaroni-dialog-config';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ManageErrorsInterceptor implements HttpInterceptor {
  private disabledRegExpRoutes: RegExp[] = [
    /\/login/i,
    /\/validate/i,
    /\/invitations\/\d+\/accepts/i,
    /\/invitations\/\d+\/rejects/i,
  ];

  private errorHandlerService = inject(ErrorHandlerService);
  private router = inject(Router);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let errorInfo: HttpErrorResponse = null;

    return next.handle(req).pipe(
      tap(
        () => {},
        error => {
          if (error instanceof HttpErrorResponse) {
            errorInfo = error;
          }
        }
      ),
      finalize(() => {
        if (errorInfo !== null) {
          console.error('INTERCEPTOR', errorInfo);

          if (this.errorHandlerService.hasControlledError(errorInfo)) {
            const valueCode = this.errorHandlerService.getErrorCode(errorInfo);
            if (valueCode === 'E0008') {
              this.router.navigate([`/`]);
            }
          }

          if (
            !this.errorIsTokenInvalid(errorInfo.status) &&
            !this.urlBelongsToDisabledRegExpRoutes(req.url)
          ) {
            const dialogConfig = new QaroniDialogConfig<HttpErrorResponse>();
            dialogConfig.data = errorInfo;
            dialogConfig.width = '768px';
          }
        }
      })
    );
  }

  private errorIsTokenInvalid(status: number): boolean {
    if (status === 401 || status === 403) {
      return true;
    } else {
      return false;
    }
  }

  private urlBelongsToDisabledRegExpRoutes(url: string): boolean {
    let belong = false;

    for (const regExpRoute of this.disabledRegExpRoutes) {
      if (regExpRoute.test(url)) {
        belong = true;
        break;
      }
    }

    return belong;
  }
}
